import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { StaticConnectionsBeat } from '../components/StaticConnectionsBeat';
import { TwelveTabProblem } from '../components/TwelveTabProblem';
import { WorkYouCantGetTo } from '../components/WorkYouCantGetTo';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4600" />
      {/* <NovaSection /> Hidden per user request */}
      {/* Integration beat — sits directly beneath the hero (right below the
                                          "Trusted by fast-moving teams" carousel). A calm static
                                          "Shared intelligence for your stack" statement runs a marquee of
                                          app-logo tiles beneath it. The scroll-driven morph still lives on
                                          /chat-transition. */}
      <StaticConnectionsBeat data-id="element-4601" />
      {/* Problem statement — names the "too many tabs / context-switch tax"
                  pain, placed right under the connected-stack beat above it. */}
      <TwelveTabProblem data-id="element-4602" />
      {/* Bridge beat — "Giga lives in the chats." Shows Giga answering right
                  inside Slack (reactive: it answers when asked), setting up the
                  proactive autonomy payoff later in the page. */}
      <LivesInSlack data-id="element-4603" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
                                                  audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4604" />
      <AudienceSwitch data-id="element-4605" />
      {/* "Built to do the work…" capability grid (four items). */}
      <CapabilityGrid data-id="element-4606" />
      {/* Proactive autonomy crescendo — "You didn't ask, Giga noticed." Placed
            here as the final, biggest capability claim (the dark beat caps the
            capability story) right before the social-proof quote/reviews. Seam:
            light CapabilityGrid → dark here → orange NarrativeSection. */}
      <WorkYouCantGetTo data-id="element-4607" />
      <NarrativeSection data-id="element-4608" />
      <ToolComparison data-id="element-4609" />
      <WallOfLove data-id="element-4610" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                                              for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-4611" />
    </>;
}